<template>
  <div class="devicesPower app-container">
    <div class="global-header-wrap">
      <h3>搜索站点管理</h3>
      <div class="devicesPower-header-right">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'searchSiteAdd' })"
        >
          新增
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <!-- <div slot="header">
        <div class="global-table-header">
          <div class="devicesPower-header-btn-left">
            <list-search ref="listSearch" @listSearchEvn="listSearchFun" />
          </div>
        </div>
      </div> -->
      <div class="global-body-wrap">
        <appTable
          :tableData="tableData"
          :tableProps="tableProps"
          :selectCtrl="false"
          @tableHandle="tableHandle"
        />
      </div>
      <pagination
        :pageSize="params.limit"
        :total="total"
        @pageNum="getPageNum"
      />
    </el-card>
    <el-dialog
      title="设备用电信息"
      :visible.sync="centerDialogVisible"
      width="50%"
      center
    >
      <div v-if="tagItem">
        <div class="devicesPower-dialog-item">
          <p>标题</p>
          <p>{{ tagItem.title }}</p>
        </div>
        <div class="devicesPower-dialog-item">
          <p>休眠时耗电</p>
          <p>{{ tagItem.sleep }}</p>
        </div>
        <div class="devicesPower-dialog-item">
          <p>工作时耗电</p>
          <p>{{ tagItem.working }}</p>
        </div>
        <div class="devicesPower-dialog-item">
          <p>设备型号</p>
          <p>{{ tagItem.model.join("\\") }}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import listSearch from "@/components/listSearch";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
export default {
  components: {
    listSearch,
    appTable,
    pagination
  },
  computed: {
    rules() {
      let rules = {
        name: [
          { required: true, message: this.$t("verify.tag"), trigger: "blur" }
        ]
        // models: [
        //   { required: true, message: this.$t("verify.tag"), trigger: "blur" }
        // ]
      };
      return rules;
    },
    tableProps() {
      let tableProps = [
        {
          prop: "name",
          label: "名称"
        },
        {
          prop: "link",
          label: "连接",
          width: 250
        },
        {
          prop: "lang",
          label: "语言"
        },
        {
          prop: "updatedAt",
          label: "创建时间"
        },
        {
          prop: "handle",
          label: this.$t("commonMsg.handle"),
          width: 120,
          btn: [
            this.$t("commonMsg.edit"),
            // this.$t("commonMsg.checkDetails"),
            this.$t("commonMsg.del")
          ]
        }
      ];
      return tableProps;
    }
  },
  mixins: [listMixin],
  data() {
    return {
      ruleForm: {
        name: "",
        models: ""
      },
      params: {
        limit: 20,
        page: 1
      },
      tableData: [],
      total: 0,
      title: "",
      tagItem: null,
      centerDialogVisible: false
    };
  },
  methods: {
    getList() {
      this.$http.getThirdsite(this.params).then(res => {
        this.tableData = res.data.results;
        this.total = res.data.count;
      });
    },

    del(data) {
      this.$http.delThirdsite(data.row._id).then(res => {
        this.elMsg(this.$t("alertMsg.delSuccess"), "success");
        this.tableData.splice(data.$index, 1);
      });
    },

    toDetails(data) {
      this.tagItem = data.row;
      this.centerDialogVisible = true;
    },

    edit(data) {
      this.$router.push({
        name: "searchSiteAdd",
        query: { id: data.row._id }
      });
    },

    addEvn(data) {
      data.models = data.models.split("\\");
      if (this.title === "新增标签") {
        this.$http.createModelGroups(data).then(res => {
          this.elMsg(this.$t("alertMsg.addSuccess"), "success");
          this.getList();
        });
      } else {
        this.$http.updateModelGroups(this.tagItem._id, data).then(res => {
          this.elMsg(this.$t("alertMsg.editSuccess"), "success");
          this.getList();
        });
      }
    },

    listSearchFun(val) {
      if (val) {
        this.params.name = val;
      } else {
        delete this.params.name;
      }
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.devicesPower {
  .devicesPower-btn {
    text-align: right;
    padding: 10px;
  }
  .devicesPower-pagination {
    padding: 10px;
    text-align: right;
  }
  .devicesPower-dialog-item {
    padding: 10px 0;
    line-height: 25px;
    > p:first-child {
      font-weight: bold;
    }
  }
}
</style>
